import { createSelector, Selector } from 'reselect';

import { VatRate } from 'types/VatRate';
import * as c from 'constants/vatRatesDB';

import { getSelectedPos } from './PointsOfSale';

export default (state: VatRate[] | null = null, { type, payload }) => {
  switch (type) {
    case c.SET_VATRATES:
      return payload;
    default:
      return state;
  }
};

export const getVatRatesFetching = state => !state.vatRatesDB;
export const getVatRates: Selector<any, VatRate[]> = state =>
  state.vatRatesDB ?? [];
export const getActiveVatRates = createSelector(
  state => getVatRates(state),
  rates => rates.filter(rate => Number(rate.active) !== 0),
);
export const getTaxFreeVatRate = createSelector(
  state => getActiveVatRates(state),
  rates => rates.find(rate => Number(rate.rate) === 0),
);
export const getVatRateByID = id =>
  createSelector(getVatRates, vatRates =>
    vatRates.find(vRate => String(vRate.id) === String(id)),
  );

export const getSelectedPosVatRate = state => {
  const selectedPOS = getSelectedPos(state);
  return getVatRateByID(selectedPOS?.vatrateID)(state);
};
